import { Skeleton } from '@crehana/compass.ui/skeleton';

import {
  TimeAttendanceMarkStatus,
  type TimeAttendanceMarkType,
} from '@/generated/graphql/types';

import { MARK_TYPE_LABELS } from '../constants';
import { useWidgetClockContext } from '../context-clock';
import { useTranslation } from '../i18n';
import { StatusTag } from './status-tag';

type TMarkSlotsListProps = {
  timeZone: string;
};
export const MarkSlotsList = ({ timeZone }: TMarkSlotsListProps) => {
  const { loading } = useWidgetClockContext();

  if (loading) {
    return <MarkSlotsListSkeleton />;
  }

  return <MarkSlotsListContent timeZone={timeZone} />;
};

const MarkSlotsListContent = ({ timeZone }: TMarkSlotsListProps) => {
  const { t } = useTranslation();

  const { data } = useWidgetClockContext();

  const expectedMarks = data?.expected_marks ?? [];

  return (
    <div className="tw-flex tw-flex-col">
      {expectedMarks.map((mark, index) => {
        const labelKey =
          MARK_TYPE_LABELS[mark.mark_type as TimeAttendanceMarkType];
        const isLast = index === expectedMarks.length - 1;
        const isPending =
          mark.status === TimeAttendanceMarkStatus.Pending && !mark.marked_at;

        return (
          <div
            key={mark.mark_type}
            className={`tw-flex tw-justify-between tw-items-center tw-py-1.2 tw-gap-1.2 ${
              !isLast
                ? 'tw-border-b tw-cds-border-color-default tw-border-solid'
                : ''
            }`}
          >
            <span className="tw-cds-font-body-01-md tw-truncate">
              {t(labelKey)}
            </span>

            {isPending ? (
              <span className="tw-cds-font-body-01 tw-flex-shrink-0">
                {t('sin_registro')}
              </span>
            ) : mark.marked_at ? (
              <StatusTag
                status={mark.status}
                markedAt={mark.marked_at}
                timeZone={timeZone}
              />
            ) : (
              <span className="tw-cds-font-body-01 tw-flex-shrink-0">
                {t('sin_registro')}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

const MarkSlotsListSkeleton = () => {
  const { t } = useTranslation();

  const items = Object.values(MARK_TYPE_LABELS);

  return (
    <div className="tw-flex tw-flex-col tw-flex-1">
      {items.map((labelKey, index) => (
        <div
          key={labelKey}
          className={`tw-flex tw-justify-between tw-items-center tw-py-1.6 ${
            index < items.length - 1
              ? 'tw-border-b tw-cds-border-color-default tw-border-solid'
              : ''
          }`}
        >
          <span className="tw-cds-font-body-01-md">{t(labelKey)}</span>
          <Skeleton className="tw-h-1.6 tw-w-12" />
        </div>
      ))}
    </div>
  );
};
